export default __webpack_public_path__ + "img/92e657d4bd79f7e2a336468dac854e4e.png";